/* Dentellis — sélectionne automatiquement les options qui n'ont qu'une seule valeur (ex. Couleur : Gris).
   Le thème ne présélectionne plus la taille (réglage « No pick ») : sans ce script, la cliente devrait
   aussi « choisir » l'unique couleur. S'applique à la fiche produit et à l'ajout rapide (fenêtre chargée à la demande).
   Le clic n'est pris en compte qu'une fois les scripts Kalles prêts : on réessaie jusqu'à ce que la valeur soit
   réellement sélectionnée (classe is--selected), pendant 8 secondes au plus. */
(function () {
  function aChoisir(racine) {
    var res = [];
    var options = racine.querySelectorAll('[data-swatch-option]');
    for (var i = 0; i < options.length; i++) {
      var items = options[i].querySelectorAll('[data-swatch-item]');
      if (items.length === 1 && !items[0].classList.contains('is--selected')) res.push(items[0]);
    }
    return res;
  }
  function choisir(racine) {
    var essais = 0;
    (function essai() {
      var restants = aChoisir(racine);
      if (!restants.length || essais++ > 26) return;
      restants.forEach(function (el) { el.click(); });
      setTimeout(essai, 300);
    })();
  }
  function demarrer() {
    var fiche = document.querySelector('.t4s-main-product__content');
    if (fiche) setTimeout(function () { choisir(fiche); }, 300);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var ajout = mutations[i].addedNodes;
        for (var j = 0; j < ajout.length; j++) {
          var n = ajout[j];
          if (n.nodeType !== 1) continue;
          var qs = n.matches && n.matches('.t4s-product-quick-shop') ? n : n.querySelector && n.querySelector('.t4s-product-quick-shop');
          if (qs) setTimeout(function () { choisir(qs); }, 300);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
